import { DisciplinasSubdisciplinasLista } from './../../models/disciplinas_subdisciplinas_lista';
import { IGetDisciplinasSubdisciplinasByProjetoUseCase } from "../../../presentation/useCases/read/get_disciplinas_subdisciplinas_by_projeto_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetDisciplinasSubdisciplinasByProjetoUseCase
 */

export class GetDisciplinasSubdisciplinasByProjetoUseCase implements IGetDisciplinasSubdisciplinasByProjetoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(
    idProjeto: number,
    tipo?: number | null,
    prancha?: string | null,
    revisao?: string | null,
    descricao?: string | null,

  ): Promise<DisciplinasSubdisciplinasLista[]> {
    return await this.repository.getDisciplinasSubdisciplinasByProjeto(
      idProjeto,
      tipo,
      prancha,
      revisao,
      descricao

    );

  }
}
